import ListItem from "components/primitives/ListItem";

interface ListboxSpacerProps {
  height: number;
}

/** Gives the listbox its scroll height without nesting a div inside it. */
function ListboxSpacer({ height }: ListboxSpacerProps) {
  return <ListItem aria-hidden role="presentation" sx={{ pointerEvents: "none", height }} />;
}

export default ListboxSpacer;
